import { Certificate } from './certificateTypes';
import { Enrollment } from './enrollmentTypes';
import { Institute } from './instituteTypes';
import { Review, ReviewRequest } from './reviewTypes';
import { Submission } from './submissionTypes';
import { Survey } from './surveyTypes';
import { ThirdPartyTrial, Trial } from './trialTypes';
import { TrialTagMapping } from './trialTagTypes';
import { DigitalSurvey } from '.';
/** Core Data Model */
export interface QuipUser {
  id: number;
  gender: 'male' | 'female' | 'diverse';
  title: string;
  position: string;
  firstname: string;
  surname: string;
  commLanguage: string;
  notificationOptOut: boolean;
  activated: boolean;
  registrationData: unknown;
  registrationdate: string; // ISO-Date-string
  realm: unknown;
  username?: string;
  password: string;
  email: string;
  emailVerified: boolean;
  verificationToken?: string;
  instituteId: number;
  userCountry: string;
  newsletterOptIn: boolean;
}

export type EditableUserData = Omit<QuipUser, 'id'|'activated'|'registrationData'|'registrationdate'|'realm'|'password'|'emailVerified'|'instituteId'>;

/** Redux types */
export type QuipUserWithInstitute = QuipUser & { institute: Institute };

export type UserById = {
  [key: number]: QuipUser;
}
export interface UserState {
  token?: UserTokenData;
  byId?: UserById,
  allIds?: number[],
}

export interface UserTokenData {
  id: string;
  ttl: number;
  created: string; // ISO string
  userId: number;
  userCountry?: string;
  role: string;
  roles: string[];
  institute: {
    patientCare: string;
    country: string;
    id: number;
  };
  email: string;
}

export type UserRegistrationData = {
  gender: string;
  title: string;
  firstname: string;
  surname: string;
  email: string;
  password: string;
  position?: string;
  commLanguage: string;
  newsletterOptIn: boolean;
  registrationdata?: {
    instituteData: unknown;
    invoiceData: unknown;
    certificationData: unknown;
  },
  forceEmailVerified?: boolean;
  instituteId?: number;
  userCountry: string;
};

export type UserManagementRow = Omit<QuipUser, 'realm' | 'registrationData'> & {
  userId: string;
  instituteName?: string;
  instituteCity?: string;
  instituteZip?: string;
  instituteCountry?: string;
};

export type UserCertificateRequest = Certificate & {
  enrollment: Enrollment & {
    trial: Trial & {
      survey?: Survey,
      digitalSurveys?: DigitalSurvey[],
      globalEvaluationReport: unknown;
      thirdPartyTrial: ThirdPartyTrial;
      trialTagMapping?: TrialTagMapping[],
    };
    submission: Submission & {
      review: Review & {
        reviewRequest: ReviewRequest;
      };
    };
    quipUser: {
      firstname: string;
      surname:string;
      id: number;
    };
  }
};

/** Redux constants */

export const LOGGED_IN = 'LOGGED_IN';
export const LOGGED_OUT = 'LOGGED_OUT';
export const SET_USERS = 'SET_USERS';
export const CLEAR_USERS = 'CLEAR_USERS';
export const UPDATE_USERS = 'UPDATE_USERS';

/** Action types */

type LoggedInAction = {
  type: typeof LOGGED_IN;
  payload: {
    email: string;
    token: UserTokenData;
  };
}

type LoggedOutAction = {
  type: typeof LOGGED_OUT;
}

type SetUserAction = {
  type: typeof SET_USERS;
  payload: QuipUser[];
}

type clearUserAction = {
  type: typeof CLEAR_USERS;
}

type updateUsersAction = {
  type: typeof UPDATE_USERS;
  payload: QuipUser[];
}

export type UserActionTypes = LoggedInAction | LoggedOutAction
| SetUserAction | clearUserAction | updateUsersAction;
